// Semantic space tokens
const space = {
  "0": "0rem",
  "2": "0.125rem",
  "4": "0.25rem",
  "8": "0.5rem",
  "12": "0.75rem",
  "16": "1rem",
  "24": "1.5rem",
  "32": "2rem",
  "40": "2.5rem",
  "48": "3rem",
  "56": "3.5rem",
  "64": "4rem",
  "72": "4.5rem",
  "80": "5rem",
  "88": "5.5rem",
  "96": "6rem",
} as const

export { space }
